import React from "react";
import { ReactComponent as Sparkle } from 'assets/icons/sparkle.svg'

// styles
import injectSheet from 'react-jss';
import styles from './newstatus_styles';

const NewStatus = injectSheet(styles)((props) => {
  return (
    <div className={`${props.classes.newstatus} ${props.klass}`} style={props.style}>
      New <Sparkle />
    </div>
  )
});

export default NewStatus;